class SeeMoreComponent extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
    this.maxHeight = null;
    this.contentElement = null;
    this.toggleButton = null;
    this.toggleText = null;
  }

  connectedCallback() {
    this.maxHeight = parseInt(this.dataset.readMoreLength) || 200;

    this.contentElement = this.querySelector('[data-ref="see-more-content"]');
    this.toggleButton = this.querySelector('[data-ref="see-more-toggle"]');
    this.toggleText = this.querySelector('.see-more__toggle-text');

    if (!this.contentElement || !this.toggleButton) return;

    this.#setInitialHeight();
    this.toggleButton.addEventListener('click', () => this.#toggle());
  }

  #setInitialHeight() {
    this.contentElement.style.maxHeight = `${this.maxHeight}px`;
    this.contentElement.style.overflow = 'hidden';
    this.contentElement.style.transition = 'max-height 0.3s ease';
  }

  #checkIfToggleNeeded() {
    // Clone hors DOM pour mesure fiable — contourne le bug iOS où scrollHeight
    // est faussé par un parent overflow:hidden
    const clone = this.contentElement.cloneNode(true);
    clone.style.position = 'fixed';
    clone.style.top = '-9999px';
    clone.style.left = '-9999px';
    clone.style.maxHeight = 'none';
    clone.style.overflow = 'visible';
    clone.style.width = `${this.contentElement.offsetWidth}px`;
    clone.style.visibility = 'hidden';
    document.body.appendChild(clone);

    const actualHeight = clone.scrollHeight;
    document.body.removeChild(clone);

    if (actualHeight <= this.maxHeight) {
      this.toggleButton.style.display = 'none';
      this.contentElement.classList.add('see-more__content--no-overflow');
    }
  }

  #toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      this.contentElement.style.maxHeight = `${this.contentElement.scrollHeight}px`;
      this.contentElement.classList.add('see-more__content--expanded');
      this.toggleText.textContent = this.toggleText.dataset.lessText || '↑';
    } else {
      this.contentElement.style.maxHeight = `${this.maxHeight}px`;
      this.contentElement.classList.remove('see-more__content--expanded');
      this.toggleText.textContent = this.toggleText.dataset.moreText || '↓';
    }

    this.dispatchEvent(
      new CustomEvent('see-more:toggle', {
        detail: { isExpanded: this.isExpanded },
        bubbles: true,
      }),
    );
  }
}

customElements.define('see-more-component', SeeMoreComponent);
